import React from 'react';
import { useExporter } from 'react-admin-base';
import { Button, Col } from "reactstrap";
export default function ExcelExportButton({ name, header, params, size, map, extra }) {
    const [handleExport, loading] = useExporter(header, params, map, extra);
    return React.createElement(Col, null,
        React.createElement(Button, { className: "w-100 d-block", type: "button", size: size, color: "success", outline: true, disabled: !!loading, onClick: () => handleExport(name) }, loading ? React.createElement("i", { className: "fas fa-spin fa-spinner" }) : React.createElement("i", { className: "fas fa-file-excel" })));
}
